import React from 'react'
import Header from './components/Header'
import Footer from './components/Footer'
import Main from './Main'

const App = () => (
  <div>
    <Header />
    <Main />
    <Footer />
  </div>
)

export default App


// WEBPACK FOOTER //
// ./src/App.js